// extracted by mini-css-extract-plugin
module.exports = {"contain":"user_contain__ZhT0c","create":"user_create__hYLqZ","createFormContainer":"user_createFormContainer__wiyFc"};